import store from "@/store"
import axios from "axios"

const RESTART_COUNTDOWN_MIN = 30
const RESTART_COUNTDOWN_MAX = 120
let restartInProgress = false
let restartInterval = null
let offlineListenerRegistered = false
let onlineListenerRegistered = false

let waitingForOnline = false

function _getRestartCountdown() {
  return Math.floor(Math.random() * (RESTART_COUNTDOWN_MAX - RESTART_COUNTDOWN_MIN + 1) + RESTART_COUNTDOWN_MIN)
}

function _reloadToRoot() {
  if (restartInterval) {
    clearInterval(restartInterval)
    restartInterval = null
  }

  // Verify actual server reachability before navigating
  fetch(`${__.platform.baseUrl}/api/health?t=${Date.now()}`, { method: "HEAD", cache: "no-store" })
    .then(() => {
      restartInProgress = false
      waitingForOnline = false
      window.location.assign(`${window.location.origin}/`)
    })
    .catch(() => {
      waitingForOnline = true
      store.commit("error", "Waiting for network connection...")
      setTimeout(_reloadToRoot, 5000)
    })
}

function _triggerPlatformRestart(reason) {
  if (restartInProgress) return
  restartInProgress = true

  let remaining = _getRestartCountdown()
  store.commit("error", `${reason} The platform will reload itself in ${remaining} seconds.`)
  restartInterval = setInterval(() => {
    remaining--
    if (remaining <= 0) {
      _reloadToRoot()
    } else {
      store.commit("error", `${reason} The platform will reload itself in ${remaining} seconds.`)
    }
  }, 1000)
}

export default () => {
  const api = axios.create({
    baseURL: __.platform.baseUrl,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Platform-Language": store.getters.language.code,
      "Channel-Language": sessionStorage.getItem("channel-language") || store.getters.language.code,
      "Device-Type": __.device.properties.type
    }
  })

  api.interceptors.response.use(
    response => response.data,
    err => {
      // If restart countdown is active, block all other error handling to keep countdown visible
      if (restartInProgress || waitingForOnline) return new Promise(() => {})

      if (!err.response) {
        _triggerPlatformRestart("Network error occurred.")
        return new Promise(() => {})
      }

      if (!store.state.router && [500, 502, 503, 504].includes(err.response?.status || err.status)) {
        _triggerPlatformRestart("Something went wrong.")
        return new Promise(() => {})
      }

      if (store.state.splash && (!err.response || err.response.data === "connect ETIMEDOUT"))
        store.commit("error", err.response ? err.response.data : err.message || err)

      if (!err.response || err.response.status === 404) return false
      if (!store.state.router && [402, 401, 406, 426].includes(err.response?.status || err.status))
        store.commit("error", err.response ? err.response.data : err)
      return _$.error(err.response ? err.response.data : err)
    }
  )

  if (!offlineListenerRegistered) {
    offlineListenerRegistered = true
    window.addEventListener("offline", () => {
      if (!navigator.onLine) _triggerPlatformRestart("Network connection lost.")
    })
  }

  if (!onlineListenerRegistered) {
    onlineListenerRegistered = true
    window.addEventListener("online", () => {
      if (restartInProgress || waitingForOnline) _reloadToRoot()
    })
  }

  return api
}
